import type { RouteRecordRaw } from 'vue-router'
import { LOGINOUT_PAGE, PAGE_BUILDING, PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from './basic'

const modules = import.meta.glob('./modules/**/*.ts', { eager: true })
const routeModuleList: RouteRecordRaw[] = []

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
  const mod = (modules as Recordable)[key].default || {}
  const modList = Array.isArray(mod) ? [...mod] : [mod]
  routeModuleList.push(...modList)
})

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList]

// 根路由
export const RootRoute: RouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: '/index',
}

export const LoginRoute: RouteRecordRaw = {
  path: '/login',
  component: () => import('@/views/sys/user/login.vue'),
  meta: {
    title: '登录',
  },
}

// Basic routing without permission
// 未经许可的基本路由
export const basicRoutes = [
  LoginRoute,
  RootRoute,
  PAGE_BUILDING,
  LOGINOUT_PAGE,
  ...routeModuleList,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
]
